import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { RouteLocation, Router, type RouteLocationAsRelative } from 'vue-router';

export function getPageRoute(
  pageName: string,
  language: HgSupportedLanguage,
  offerType?: OfferType,
  options?: object,
): RouteLocationAsRelative {
  return {
    name: `${pageName}${offerType ? '-' + offerType : ''}-${language}`,
    ...options,
  };
}

export function normalizedFullPath(route: RouteLocation, router: Router): string {
  const normalizedPageRoute = {
    params: route.params,
    ...getPageRoute(
      route.name?.toString().split('-')[0] || '',
      HgSupportedLanguage.EN,
      route.meta?.offerType as OfferType | undefined,
    ),
  };
  const resolvedRoute = router.resolve(normalizedPageRoute);

  if (!resolvedRoute) {
    return '';
  }

  return resolvedRoute?.fullPath ?? '';
}
